import { useIntl } from '@weenat/wintl'
import { useNavigate, useSearchParams } from 'app/routx-router'
import Button from 'app/src/kit/Button'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'
import { useToken } from 'app/state'
import isNil from 'lodash-es/isNil'
import { styled } from 'styled-components'

const StyledButton = styled(Button)`
  align-self: center;
`

const BackButton = () => {
  const { t } = useIntl()
  const [token] = useToken()
  const nav = useNavigate()

  return (
    <StyledButton
      importance='sd'
      variant='compact'
      onPress={() => {
        nav('/')
      }}
    >
      {t(isNil(token) ? 'actions.go_back_to_login' : 'actions.go_back_to_app')}
    </StyledButton>
  )
}

export const Component = () => {
  const { t } = useIntl()
  const [params] = useSearchParams()
  const errorCode =
    !isNil(params) &&
    typeof params === 'object' &&
    'errorCode' in params &&
    typeof params.errorCode === 'string'
      ? Number.parseInt(params.errorCode, 10)
      : 0
  return (
    <>
      <Text $fontSize='lg'>{t('auth.verification_success_title')}</Text>
      <div>
        <EmptyStateWithRipple
          tint='feedback.error.500'
          title={
            errorCode === 404
              ? t('auth.verify_email_link_expired')
              : t('errors.noun', { capitalize: true })
          }
          description={
            errorCode === 404
              ? t('auth.verify_email_link_expired_explained')
              : t('auth.verify_email_not_found')
          }
          Icon={Icons.Error}
        >
          <Flex $flexDirection='column' $gap='lg' $mt='lg'>
            <BackButton />
          </Flex>
        </EmptyStateWithRipple>
      </div>
    </>
  )
}
export default Component
